const initialState = {
    str: ''
}

const stcwPlaceIssueRed = (state = initialState, action) => {
    switch(action.type){
        case 'STCW_PLACE_ISSUE' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default stcwPlaceIssueRed